import { fetch as apiFetch } from '../fetchWrapper/fetch';
import { MARKETPLACE_API_URL } from '../constants';

export interface ItemCapacity {
  section: number;
  item: number;
  option_groups: number;
  options_per_group: number[];
}

export interface DesignAsset {
  id: string;
  title: string;
  thumbnail_url: string | null;
  orientation: 'portrait' | 'landscape' | 'square' | null;
  size: 'A_SERIES' | 'LETTER' | 'LEGAL' | 'SQUARE' | 'WIDESCREEN' | '4_3' | null;
  updated_at: string; // ISO date string
  sections: number;
  items_per_section: number[];
  item_capacity: ItemCapacity[];
  has_venue: boolean;
  has_opening_times: boolean;
  type: string;
}

// Response from service-marketplace -> connector-canva chain
export interface GetTemplatesResponse {
  type: 'addon_assets';
  data: {
    addon_name: string;
    integration_type: string;
    payload: {
      type: 'menu_templates';
      data: DesignAsset[];
    };
  };
}

export const getTemplates = async (addonId: string): Promise<DesignAsset[]> => {
  const response = await apiFetch(`${MARKETPLACE_API_URL}/addons/${addonId}/assets?type=templates`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const json: GetTemplatesResponse = await response.json();
  return json.data.payload.data;
};
